import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Typography } from "@mui/material";

am4core.useTheme(am4themes_animated);

export default function ReportChat(props) {
  const { onClick, data } = props;

  useLayoutEffect(() => {
    // Chat 1 EBU
    const chart = am4core.create("chartdiv95", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

    chart.data = [
      {
        country: "Logged In",
        litres: data?.loginCount ?? 0,
        login: true,
      },
      {
        country: "Not Logged In",
        litres: data?.nonLoginCount ?? 0,
        login: false,
      },
    ];

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";

    // Let's cut a hole in our Pie chart the size of 40% the radius
    chart.innerRadius = am4core.percent(40);

    // Set up fills
    pieSeries.slices.template.fillOpacity = 1;

    pieSeries.slices.template.events.on("hit", function (ev) {
      onClick(ev.target._dataItem?._dataContext?.login);
    });

    var hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1;
    hs.properties.fillOpacity = 0.5;

    let totalLabel = chart.createChild(am4core.Label);
    // totalLabel.text = "";
    totalLabel.fontSize = 20;
    totalLabel.align = "center";

    return () => {
      chart.dispose();
    };
  }, []);

  if (!data?.totalUser) {
    return <Typography>No data found</Typography>;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "500px",
        direction: "ltr",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      }}
    >
      <div
        id="chartdiv95"
        style={{ width: "100%", height: "350px", direction: "ltr" }}
      />
    </div>
  );
}
